import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { LocationsHttpClient } from '../locations-http-client';
import { CountryActions } from './countries.store';

@Injectable({ providedIn: 'root' })
export class CountriesEffects {
  public effect = createEffectFactory(CountryActions, this.actions$);

  public fetchCountries$ = this.effect(CountryActions.fetch, () =>
    this.locationsHttpClient.fetchCountries(),
  );

  constructor(private locationsHttpClient: LocationsHttpClient, private actions$: Actions) {}
}
